@if (corporateTaxEntity$ | async) {
  <form [formGroup]="ontbindingFg">
    <div formArrayName="ontbinding">
      @for (item of ontbinding.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Naam dochter' : ''"
              [required]="true"
              class="custom-input-250"
              formControlName="naamDochter"
              id="naamDochter-{{i}}"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-date-form-control
              [label]="i === 0 ? 'Ontbindingsdatum' : ''"
              [required]="true"
              class="custom-input-150"
              formControlName="ontbindingsdatum"
              id="ontbindingsdatum-{{i}}"
            >
            </snelstart-ui-date-form-control>
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Onbetaald gebleven schulden' : ''"
              [required]="true"
              [showAllDecimals]="false"
              align="right"
              class="custom-input-200"
              formControlName="onbetaaldGeblevenSchulden"
              id="onbetaaldGeblevenSchulden-{{i}}"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
              icon="trash"
              iconType="light"
              id="buttonDelete-{{i}}"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    class="snelstart-ui-button"
    icon="plus"
    id="cancel"
    type="link"
  >Vennootschap toevoegen
  </snelstart-ui-button>
}
